export default "__VITE_ASSET__CLNntWY___"